import type { TabProps } from "@dealer-center/core-components";
import { Tabs } from "@dealer-center/core-components";
import { useLocation, useNavigate } from "react-router-dom";
import { useSplatBasePath } from "@dealer-center/core-custom-components";
import styled from "styled-components";
import { useEffect, useState } from "react";
import type { routes } from "./tabList";
import { getListOfTabs, routeIndexMapping } from "./tabList";
import { useGetAccount } from "@dealer-center/ddc-api-account-fetch";
import { useCC9Flags } from "@dealer-center/core-third-party-launch-darkly";
import { useDdcExperimentPreferences } from "@dealer-center/core-pages-experiment-enablement-hook";

export const StyledTabs = styled(Tabs)`
  button.btn.btn-link {
    background-color: inherit;
    &:hover {
      background-color: inherit;
    }
  }
  li.cx-tabs--active {
    button.btn.btn-link {
      background-color: inherit;
    }
  }
`;

export const StyledPagesLandingPage = styled.div``;
export function Layout() {
  const [tabs, setTabs] = useState<TabProps[] | undefined>(undefined);
  const { data: accountEntity } = useGetAccount();
  const cc9Flags = useCC9Flags();
  const { experiments } = useDdcExperimentPreferences();
  useEffect(() => {
    if (!accountEntity || !accountEntity) return;
    document.title = `${accountEntity.name || accountEntity.id} - Dashboard`;
  }, [accountEntity]);
  const navigate = useNavigate();
  const location = useLocation();
  // Layout is the element of the `dashboard/*` splat route, so a relative
  // navigate() would append to the currently-matched tab under react-router v7
  // (e.g. /dashboard/overview -> /dashboard/overview/departments). Build an
  // absolute target off the splat's parent instead.
  const basePath = useSplatBasePath();
  useEffect(() => {
    if (!accountEntity) return;
    setTabs(getListOfTabs(accountEntity, location, cc9Flags, experiments));
  }, [accountEntity, location, cc9Flags]);
  return (
    <StyledPagesLandingPage>
      {tabs && accountEntity && accountEntity && (
        <>
          <h1>{accountEntity.name || accountEntity.id} - Dashboard</h1>
          <StyledTabs
            tabs={tabs}
            onActivate={(index: number) => {
              const route = Object.keys(routeIndexMapping).find(
                key => routeIndexMapping[key as routes] === index
              );
              if (route) {
                navigate(`${basePath}/${route}`);
              }
            }}
          />
        </>
      )}
    </StyledPagesLandingPage>
  );
}
